import "./About.css";
import Footer from "../components/Footer";

const ManufacturerDetails = () => {
  return (
    <>
      {/* PAGE CONTENT */}
      <div
        style={{
          minHeight: "70vh",
          backgroundColor: "#f3f3f3",
          padding: "140px 20px 60px",
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: "650px",
            backgroundColor: "#ffffff",
            borderRadius: "18px",
            padding: "28px 24px",
            boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
          }}
        >
          <h2
            style={{
              color: "#2f6b3f",
              fontSize: "28px",
              fontWeight: "700",
              marginBottom: "18px",
            }}
          >
            Manufactured by :
          </h2>

          <p
            style={{
              fontSize: "18px",
              lineHeight: "1.8",
              color: "#222",
              margin: 0,
              wordBreak: "break-word",
            }}
          >
            (A)THYLAKOID BIOTECH PVT. LTD
            <br />
            B1+B2+B3/17, GIDC, Sector-25,
            <br />
            Gandhinagar, Gujarat - 382024, India.
            <br />
            FSSAI Lic. No.: 10719027000023
          </p>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ManufacturerDetails;